import { render } from "./App.vue?vue&type=template&id=c4eec16e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c4eec16e&lang=css"

import exportComponent from "C:\\Users\\dvdsa\\projects\\avante-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__